class Helpers {
    /*
    * Parses the current URL and returns a corresponding "service-type" taxonomy ID (or false).
    * This is used for submitting the "service-type" parameter in RestAPI.js (which is handled by LocationCallback.php).
    */
    getServiceTypeIdFromCurrentUrl() {
        const url = window.location.href;

        if (url.includes('leben-und-wohnen')) return 99;
        if (url.includes('lernen-und-arbeiten')) return 98;

        return false;
    }
}

export default Helpers;
